import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { Button } from "../../button";

export const StyledActionButton = styled(Button)`
    height: 32px;
    color: ${color("color--text--neutral--strong")};
`;
